module.exports = __webpack_public_path__ + "static/media/scanner.4293384b.svg";